import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function CategoryNav() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <p className="text-xs font-semibold uppercase tracking-widest text-foreground-400 mb-3">
          热门频道
        </p>
        <h2 className="text-3xl md:text-5xl font-black font-heading text-foreground-950 leading-tight mb-12">
          选择你想吃的瓜
          <br />
          总有一款适合你
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="bg-background-50 rounded-xl p-6 md:p-8 hover:bg-background-50/80 transition-colors duration-200 group cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-50 text-primary-600 mb-5 group-hover:bg-primary-100 transition-colors">
                <i className={`${cat.icon} text-2xl`}></i>
              </div>
              <h3 className="text-xl font-bold font-heading text-foreground-950 mb-2">
                {cat.name}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {cat.description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}